import * as types from "./types";

const mutations = {
  [types.STEP_LIST](state, payload) {
    // save in store
    state.stepList = payload;
  },
  [types.SET_MIXED](state, payload) {
    state.isMixed = payload;
  },
  [types.SET_LOW_PLATE](state, payload) {
    state.lowPlate = payload;
  },
  [types.SET_HIGH_PLATE](state, payload) {
    state.highPlate = payload;
  },
  [types.SET_MIN_PLATE](state, payload) {
    state.minPlate = payload;
  },
  [types.SET_MAX_PLATE](state, payload) {
    state.maxPlate = payload;
  },
  [types.SET_GEOMETRY](state, payload){
    state.geometry = payload;
  }
};

export default mutations;
